var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllpingsInc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13281 25.5657L13.0781 15.6204L17.3234 19.8954L34.3641 2.85474",
    stroke: "#39BF8F",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2695 2.85474H34.3648V9.95005",
    stroke: "#39BF8F",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6523 22.73V34.0854",
    stroke: "white",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1719 25.5654V34.0857",
    stroke: "white",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6953 14.2102V34.086",
    stroke: "white",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllpingsInc);
export default __webpack_public_path__ + "static/media/allpings_inc.c80ea7823dffa209d6a4927ff91e68c5.svg";
export { ForwardRef as ReactComponent };